"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getManifest = exports.win = exports.createPromiseResolver = void 0;
const createPromiseResolver = () => {
    let resolve;
    const promise = new Promise(r => {
        resolve = r;
    });
    // we are overriding the resolve! here because the new Promise will definitely assign it
    return { resolve: resolve, promise };
};
exports.createPromiseResolver = createPromiseResolver;
if (typeof window !== 'undefined') {
    exports.win = window;
}
else if (typeof global !== 'undefined') {
    exports.win = global;
}
else if (typeof self !== 'undefined') {
    exports.win = self;
}
else {
    exports.win = {};
}
function getManifest(name) {
    const n = name !== null && name !== void 0 ? name : 'fox-seeourm';
    const manifest = window['manifest'].find(m => m.name == n);
    return manifest !== null && manifest !== void 0 ? manifest : {};
}
exports.getManifest = getManifest;
